import { render, staticRenderFns } from "./YongHu.vue?vue&type=template&id=3c213e76&scoped=true"
import script from "./YongHu.vue?vue&type=script&lang=js"
export * from "./YongHu.vue?vue&type=script&lang=js"
import style0 from "./YongHu.vue?vue&type=style&index=0&id=3c213e76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c213e76",
  null
  
)

export default component.exports